<template>
  <div class="link">
    <a class="link__content" :href="link.url">
      <div class="link__logo">
        <img :src="getImageSource()" class="link__logo-img" @error="handleIconLoadingError">
      </div>
      <div class="link__title">
        {{ $t(`global.products.${productTitle}.links.${link.title}`) }}
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Link } from '../../reusable/types'

@Component({
  components: {}
})
export default class LinkComponent extends Vue {
  @Prop({ required: true }) public readonly productTitle!: string
  @Prop({ required: true }) public readonly link!: Link

  public doesIconExist = true

  public getImageSource () {
    return (this.doesIconExist) ? `./icons/links/${this.link.title}.png` : null
  }

  public handleIconLoadingError () {
    this.doesIconExist = false
  }
}
</script>
